export default __webpack_public_path__ + "static/media/smallTruckLeft.cda3b7b2.jpg";